import { Controller, FieldError, FieldValues, Path } from "react-hook-form";
import { Select } from "@songtradr-one/components-frontend";
import { FormFieldWrapper } from "../../../form-field-wrapper/FormFieldWrapper";
import { Props, SelectWrapper } from "./SelectField.Parts";

export const SelectField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>({
  control,
  errors,
  rules,
  label,
  name,
  single,
  disabled,
  options,
  placeholder,
  search,
  onBlur,
}: Props<FormFields, FieldName>) => {
  return (
    <FormFieldWrapper
      $single={single}
      name={name}
      error={errors[name] as FieldError}
    >
      <Controller
        name={name}
        control={control}
        rules={{ ...rules }}
        render={({ field }) => {
          const {
            ref: _ref,
            value,
            onBlur: fieldOnBlur,
            ...fieldProps
          } = field;

          const handleBlur = (
            event: React.FocusEvent<HTMLInputElement | HTMLButtonElement>,
          ) => {
            fieldOnBlur();
            if (onBlur) onBlur(event as React.FocusEvent<HTMLInputElement>);
          };

          return (
            <SelectWrapper>
              <Select
                name={fieldProps.name}
                width="100%"
                label={label}
                search={search}
                disabled={disabled}
                floating={false}
                options={options}
                selection={value ? [value] : []}
                placeholder={placeholder}
                hasError={Boolean(errors[name])}
                onBlur={handleBlur}
                onChange={(selection) =>
                  fieldProps.onChange(selection[0] ?? "")
                }
                matchListWidth
              />
            </SelectWrapper>
          );
        }}
      />
    </FormFieldWrapper>
  );
};
